import { OnInit, OnDestroy } from '@angular/core';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { combineLatest, Subject } from 'rxjs';
import { first, map, takeUntil } from 'rxjs/operators';
import { ApplicationService } from 'services/application/application.service';
import { DialogService } from 'services/dialogs/dialogs.service';
import { ErrorService } from 'services/error/error.service';
import { ScreenSizeService } from 'services/screensize/screensize.service';
import { SplashService } from 'services/splash/splash.service';
import { UserService } from 'services/user/user.service';
import { TitleCasePipe } from 'pipes/titlecase.pipe';
var FacilitatorsComponent = /** @class */ (function () {
    function FacilitatorsComponent(appService, dialogService, errorService, screenSizeService, splashService, titleCasePipe, userService) {
        this.appService = appService;
        this.dialogService = dialogService;
        this.errorService = errorService;
        this.screenSizeService = screenSizeService;
        this.splashService = splashService;
        this.titleCasePipe = titleCasePipe;
        this.userService = userService;
        this._subrelease = new Subject();
        this.AllVisibleHeaders = ['LastName', 'FirstName', 'SAPID', 'LocalJobTitle', 'Active', 'Actions'];
        this.AllActiveVisibleHeaders = ['LastName', 'FirstName', 'SAPID', 'LocalJobTitle', 'Actions'];
    }
    FacilitatorsComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    FacilitatorsComponent.prototype.ngOnInit = function () {
        var self = this;
        self.Facilitators = [];
        self.FilteredFacilitators = [];
        self.FacilitatorsSource = new MatTableDataSource(self.FilteredFacilitators);
        self.NoData = true;
        self.ShowInactiveFacilitators = false;
        self.User = null;
        self.ViewReady = false;
        // Subscribe to changes in the screen size.
        self.screenSizeService.ScreenSizeSub.pipe(takeUntil(self._subrelease)).subscribe(function (size) {
            self.SmallDisplay = size.IsSmallSize;
            self.VisibleHeaders = self.SmallDisplay
                ? ['SmallDisplay']
                : self.ShowInactiveFacilitators
                    ? self.AllVisibleHeaders.slice()
                    : self.AllActiveVisibleHeaders.slice();
            self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
        });
        self.SmallDisplay = self.screenSizeService.ScreenSize.IsSmallSize; // Initial setting
        // Wait for the first non-null UserInfo object, to begin component life cycle.
        self.userService.UserSubject.pipe(takeUntil(self._subrelease), first(function (_u) { return _u && !!_u.AuthToken; })).subscribe(function (_user) {
            self.User = _user;
            // Set up constant user monitoring
            self.userService.UserSubject.pipe(takeUntil(self._subrelease)).subscribe(function (user) {
                self.User = user;
            }, function (error) { return self.errorService.HandleServiceError(error); });
            // Grab the information needed for the component
            combineLatest(self.appService.GetAllFacilitators())
                .pipe(takeUntil(self._subrelease), map(function (_packet) {
                return {
                    Facilitators: _packet[0],
                };
            }))
                .subscribe(function (packet) {
                self.Facilitators = packet.Facilitators || [];
                // Apply filtering
                self.UpdateFiltering();
                // The page is ready for viewing.
                self.ViewReady = true;
            }, function (error) { return self.errorService.HandleServiceError(error); });
        }, function (error) { return self.errorService.HandleServiceError(error); });
    };
    // #region Remove Facilitator
    FacilitatorsComponent.prototype.RemoveFacilitator = function (fac) {
        var self = this;
        // Get a confirmation
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: "You are about to remove the following facilitator from the IRIS System:<br /><br />" +
                ("<strong>First Name: </strong>" + self.titleCasePipe.transform(fac.FirstName) + "<br />") +
                ("<strong>Last Name: </strong>" + self.titleCasePipe.transform(fac.LastName) + "<br />") +
                ("<strong>SAP #: </strong>" + fac.SAPID + "<br />") +
                ("<strong>Title: </strong>" + fac.LocalJobTitle + "<br /><br />") +
                "Once removed, the individual will no longer have facilitator access to the IRIS System. Are you " +
                "sure you wish to continue?",
            OKText: 'Yes - Remove',
            CancelText: 'No - Cancel',
        })
            .subscribe(function (result) {
            if (result === true) {
                // Remove the person.
                self.appService.RemoveFacilitator(self.User.AuthToken, self.User.CurrentRole, fac.PersonID).subscribe(function (facilitators) {
                    // Splash success.
                    self.splashService.SnackbarSuccess('Facilitator removed successfully.');
                    // Update the list of facilitators
                    self.Facilitators = facilitators || [];
                    self.NoData = !self.Facilitators.length;
                    self.FacilitatorsSource.data = self.NoData ? [{}] : self.Facilitators;
                    // Update filtering
                    self.UpdateFiltering();
                }, function (error) { return self.errorService.HandleServiceError(error); });
            }
        });
    };
    // #endregion
    // #region Show Facilitator Form
    FacilitatorsComponent.prototype.ShowFacilitatorForm = function () {
        var self = this;
        self.dialogService
            .OpenUserSearchDialog({
            TitleText: 'District User Search',
            MessageText: "Use the form provided here to search for the employee you wish to designate as a facilitator in the IRIS System:",
            OKText: 'Make Facilitator',
            CancelText: 'Cancel',
            width: '900px',
        })
            .subscribe(function (result) {
            if (result != null) {
                // User selected a person. Send the request off to the server.
                self.appService
                    .AddFacilitator(self.User.AuthToken, self.User.CurrentRole, result.User.SAPID, result.User.PositionNo)
                    .subscribe(function (facilitators) {
                    // Splash success.
                    self.splashService.SnackbarSuccess('Facilitator added successfully.');
                    // Update the list of facilitators
                    self.Facilitators = facilitators || [];
                    self.NoData = !self.Facilitators.length;
                    self.FacilitatorsSource.data = self.NoData ? [{}] : self.Facilitators;
                    // Update filtering
                    self.UpdateFiltering();
                }, function (error) { return self.errorService.HandleServiceError(error); });
            }
        });
    };
    // #endregion
    // #region Update Filtering
    FacilitatorsComponent.prototype.UpdateFiltering = function () {
        var self = this;
        self.FilteredFacilitators = (self.Facilitators || []).filter(function (f) { return f.Active === true || self.ShowInactiveFacilitators; });
        self.NoData = !self.FilteredFacilitators.length;
        self.FacilitatorsSource.data = self.NoData ? [{}] : self.FilteredFacilitators;
        // Update column displays
        self.VisibleHeaders = self.SmallDisplay
            ? ['SmallDisplay']
            : self.ShowInactiveFacilitators
                ? self.AllVisibleHeaders.slice()
                : self.AllActiveVisibleHeaders.slice();
        self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
    };
    return FacilitatorsComponent;
}());
export { FacilitatorsComponent };
